<template>
  <div class="tabbed-view">
    <page-title tag="h1" :fixed-title="fixedTitle" :is-loading="isLoading"></page-title>
    <vs-tabs
      v-if="tabsLocal.length > 0"
      color="dark"
      v-model="tab"
      class="overflow-visible tab-action-btn-fill-container"
    >
      <vs-tab v-for="(thisTab, index) in tabsLocal" :key="index" :label="thisTab.label">
        <div class="tab-text">
          <router-view></router-view>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import CanAccessMixin from '@/components/mixins/CanAccessMixin';
import PageTitle from '@/views/components/extra-components/layout/PageTitle';

export default {
  name: 'TabbedView',
  components: { PageTitle },
  props: {
    tabs: {
      type: Array,
      required: true
    },
    fixedTitle: {
      type: String,
      required: false,
      default: null
    }
  },
  mixins: [CanAccessMixin],
  data() {
    return {
      isLoading: true,
      tab: 0,
      tabsLocal: [],
      loadingTabs: false
    };
  },
  watch: {
    tab: {
      handler(newTab, oldTab) {
        if (this.tabsLocal[newTab]) {
          this.goToRoute(this.tabsLocal[newTab].route);
          this.$emit('change', newTab);
        }
      },
      immediate: false
    },
    tabs: {
      handler() {
        this.setTabAccess();
      },
      deep: true,
      immediate: true,
    }
  },
  async mounted() {
    if (this.tabs.length === 0) {
      return;
    }

    this.tab = this.getTabIndexByRoute();
    this.$nextTick(function () { this.isLoading = false })
  },
  methods: {
    shouldBeShown(tab) {
      return !(tab.hasOwnProperty('hideIfDeleted') && tab.hideIfDeleted);

    },
    async setTabAccess() {
      this.tabsLocal = [];
      for (const tab of this.tabs) {
        if (await this.canAccessRoute(tab.route) && this.shouldBeShown(tab)) {
          this.tabsLocal.push(tab);
        }
      }
    },
    getTabIndexByRoute(route = null) {
      route = route ? route : this.$route;
      const matchedNames = route.matched.map(({ name }) => name);

      let match = this.tabs.findIndex(({ route: r }) =>
        matchedNames.includes(r)
      );

      return match ? match : 0;
    },
    goToRoute(name) {
      this.$router.push({ name }).catch(() => {});
    },
  }
};
</script>
